import DonateForm from './DonateForm';
import { useLayoutEffect, useState } from 'react';

const MultiDonateForm = ({ screenSize, donateFormParams }) => {
  const [show, setShow] = useState(false);
  const getWidth = () => window.innerWidth;

  const determineShow = () => {
    const width = getWidth();
    return (
      (screenSize == 'mobile' && width <= 640) ||
      (screenSize == 'desktop' && width > 640) ||
      screenSize == 'all'
    );
  };

  useLayoutEffect(() => {
    setShow(determineShow());

    let timeoutId = null;
    const resizeListener = () => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => setShow(determineShow()), 150);
    };

    window.addEventListener('resize', resizeListener);
    return () => {
      window.removeEventListener('resize', resizeListener);
    };
  });

  return (
    <>
      {show && (
        <div className='donate-form'>
          <div className='donate-form-container'>
            <DonateForm {...donateFormParams} />
          </div>
        </div>
      )}
    </>
  );
};

export default MultiDonateForm;
